import React from "react";
import Table from "react-bootstrap/Table";
import { Button, Modal, Form } from "react-bootstrap";
import { FaPlus, FaPencilAlt, FaTrash } from "react-icons/fa";
import withRouter from "../../util/WithRouter";
import FloorRiseAPI from "../../api/FloorRiseAPI";
import Util from "../../util/Util";
import Display from "../../util/Display";

class FloorRisePreview extends React.Component {

  constructor(props) {
    super(props);
    console.log("props",props)

    this.towerId = parseInt(props.match.params.towerId);
    this.projectId = new URLSearchParams(props.location.search).get("project");

    this.state = {
      inApiCall: false,
      showFloorRise: false,
      type: "",
      floorFrom: "",
      floorTo: "",
      value: "",
      editingId: 0,

      validation: {},
      list: []
    };
  }

  componentDidMount() {
    this.loadList();
  }

  loadList = () => {
    if (!this.towerId || !this.projectId) return;

    this.setState({ inApiCall: true });

    FloorRiseAPI.getList(
      this.projectId,
      this.towerId,
      (res) => {
        this.setState({ list: res, inApiCall: false });
      },
      (error) => {
        this.setState({ inApiCall: false });
        this.props.failure(error);
      },
      this.props.logout
    );
  };

  openFloorRise = () => {
    this.setState({
      showFloorRise: true,
      type: "", // Empty default
      floorFrom: "",
      floorTo: "",
      value: "",
      editingId: 0,
      validation: {}
    });
  };

  editFloorRise = (row) => {
    this.setState({
      showFloorRise: true,
      type: row.type.toString(),
      floorFrom: row.from_floor,
      floorTo: row.to_floor,
      value: row.value,
      editingId: row.id,
      validation: {}
    });
  };

  closeFloorRise = () => {
    this.setState({ showFloorRise: false });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'type') {
      this.setState({ 
        [name]: value,
        value: ""
      });
    } else if (name === 'floorFrom' || name === 'floorTo') {
      if (value === "" || /^[0-9]*$/.test(value)) {
        this.setState({ [name]: value });
      }
    } else if (name === 'value') {
      if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
        this.setState({ [name]: value });
      }
    }
  };

  submitFloorRise = () => {
    const { floorFrom, floorTo, type, value, editingId } = this.state;
    let validation = {};

    if (!type) validation.type = "Type is required";
    
    if (!floorFrom) validation.floorFrom = "From Floor is required";
    if (!floorTo) validation.floorTo = "To Floor is required";
    
    if (!value) validation.value = "Value is required";

    if (+floorTo < +floorFrom) {
      validation.floorTo = "To Floor cannot be less than From Floor";
    }

    if (type === "1") {
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue < 0 || numValue > 100) {
        validation.value = "Percentage must be between 0 and 100";
      }
    } else if (type === "2" || type === "3") {
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue < 0) {
        validation.value = "Amount must be a positive number";
      }
    }

    if (Object.keys(validation).length) {
      this.setState({ validation });
      return;
    }

    const payload = {
      project_id: this.projectId,
      tower_id: this.towerId,
      type: parseInt(type),
      from_floor: parseInt(floorFrom),
      to_floor: parseInt(floorTo),
      value: parseFloat(value),
      id: editingId || 0
    };

    // Show loading
    this.setState({ inApiCall: true });

    FloorRiseAPI.save(
      payload,
      (response) => {
        this.setState({ inApiCall: false });
        Util.showNotification(
          "Success",
          editingId ? "Floor rise updated" : "Floor rise added",
          "success"
        );
        this.closeFloorRise();
        this.loadList();
      },
      (error) => {
        this.setState({ inApiCall: false });
        
        let errorMessage = "";
        
        if (typeof error === 'string') {
          errorMessage = error;
        } else if (error && error.message) {
          errorMessage = error.message;
        } else if (error && typeof error === 'object') {

          errorMessage = JSON.stringify(error);
        }
        

        if (errorMessage.includes("overlaps with existing range") || 
            errorMessage.includes("overlap")) {
          
          const overlapError = errorMessage.includes("Floor range") ? 
            errorMessage : 
            "This floor range overlaps with an existing range";
          
          this.setState({ 
            validation: { 
              floorFrom: overlapError,
              floorTo: overlapError
            } 
          });
          
          Util.showNotification(
            "Overlap Error",
            overlapError,
            "danger"
          );
        } 
        else if (errorMessage.includes("required") || 
                 errorMessage.includes("invalid") ||
                 errorMessage.includes("must be") ||
                 errorMessage.includes("cannot be")) {
          
          Util.showNotification(
            "Validation Error",
            errorMessage,
            "error"
          );
          
          if (errorMessage.includes("Type") || errorMessage.includes("type")) {
            this.setState({ validation: { type: errorMessage } });
          } else if (errorMessage.includes("From") || errorMessage.includes("from")) {
            this.setState({ validation: { floorFrom: errorMessage } });
          } else if (errorMessage.includes("To") || errorMessage.includes("to")) {
            this.setState({ validation: { floorTo: errorMessage } });
          } else if (errorMessage.includes("Value") || errorMessage.includes("value") || 
                     errorMessage.includes("Percentage") || errorMessage.includes("Amount")) {
            this.setState({ validation: { value: errorMessage } });
          }
        }
        else {
          this.props.failure(error);
        }
      },
      this.props.logout
    );
  };

  deleteFloorRise = (row) => {
    Util.confirmAlert(
      "Delete",
      "Are you sure you want to delete this floor rise?",
      "Delete",
      "No",
      () => {
        FloorRiseAPI.delete(
          row.id,
          () => {
            Util.showNotification("Deleted", "Floor rise deleted", "success");
            this.loadList();
          },
          this.props.failure
        );
      }
    );
  };

  getTypeLabel = (type) => {
    switch(parseInt(type)) {
      case 1: return "Percentage Slap Wise";
      case 2: return "Amount Slap Wise";
      case 3: return "Increase Amount Floor Wise";
      default: return "Unknown";
    }
  };

  getValueDisplay = (row) => {
    const type = parseInt(row.type);
    const value = parseFloat(row.value);
    
    switch(type) {
      case 1: // Percentage Slap Wise
        return `${value}% (Percentage Slap Wise)`;
      case 2: // Amount Slap Wise
        return `₹ ${value} (Amount Slap Wise)`;
      case 3: // Increase Amount Floor Wise
        return `₹ ${value} per floor (Increase Amount Floor Wise)`;
      default:
        return row.value;
    }
  };

  renderList = () => {
    if (!this.state.list.length) {
      return (
        <tr>
          <td colSpan="10" className="text-center">No Record</td>
        </tr>
      );
    }

    return this.state.list.map((row, i) => (
      <tr key={i}>
        <td>{row.id}</td>
        <td>{Display.ModelLabelValue("project", row.project_id)}</td>
        <td>{row.tower_id}</td>
        <td>{this.getTypeLabel(row.type)}</td>
        <td>{row.from_floor}</td>
        <td>{row.to_floor}</td>
        <td>{this.getValueDisplay(row)}</td>
        <td>
          <span className="buttons update" onClick={() => this.editFloorRise(row)}>
            <FaPencilAlt /> Edit
          </span>
          <span className="buttons delete" onClick={() => this.deleteFloorRise(row)}>
            <FaTrash /> Delete
          </span>
        </td>
      </tr>
    ));
  };

  render() {
    const { showFloorRise, type, floorFrom, floorTo, value, validation, editingId, inApiCall } = this.state;

    return (
      <div className="container-fluid p-3">

        <div className="d-flex justify-content-between mb-3">
          <h3>Floor Rise</h3>
          <Button onClick={this.openFloorRise} disabled={inApiCall}>
            <FaPlus /> Add Floor Rise
          </Button>
        </div>

        <Table bordered striped hover>
          <thead>
            <tr>
              <th>ID</th>
              <th>Project</th>
              <th>Tower Id</th>
              <th>Type</th>
              <th>From Floor</th>
              <th>To Floor</th>
              <th>Rule</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{this.renderList()}</tbody>
        </Table>

        {/* MODAL */}
        <Modal show={showFloorRise} onHide={this.closeFloorRise} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {editingId ? "Edit Floor Rise" : "Add Floor Rise"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form>
              {inApiCall && (
                <div className="text-center mb-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Floor Rise Type <span className="text-danger">*</span></Form.Label>
                <Form.Control 
                  as="select" 
                  name="type" 
                  value={type} 
                  onChange={this.handleChange}
                  isInvalid={!!validation.type}
                  disabled={inApiCall}
                >
                  <option value="">Select Type</option>
                  <option value="1">Percentage Slap Wise</option>
                  <option value="2">Amount Slap Wise</option>
                  <option value="3">Increase Amount Floor Wise</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {validation.type}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>From Floor <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="floorFrom"
                      value={floorFrom}
                      onChange={this.handleChange}
                      isInvalid={!!validation.floorFrom}
                      disabled={inApiCall}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validation.floorFrom}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>To Floor <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="floorTo"
                      value={floorTo}
                      onChange={this.handleChange}
                      isInvalid={!!validation.floorTo}
                      disabled={inApiCall}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validation.floorTo}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              <Form.Group className="mb-3">
                <Form.Label>
                  {type === "1" && "Percentage (%)"}
                  {type === "2" && "Fixed Amount (₹)"}
                  {type === "3" && "Amount Per Floor (₹)"}
                  {!type && "Value"}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="value"
                  value={value}
                  onChange={this.handleChange}
                  isInvalid={!!validation.value}
                  disabled={!type || inApiCall}
                  step={type === "1" ? "0.01" : "0.01"}
                />
                <Form.Control.Feedback type="invalid">
                  {validation.value}
                </Form.Control.Feedback>
                <Form.Text className="text-muted">
                  {type === "1" && "Enter percentage value between 0-100"}
                  {type === "2" && "Enter fixed amount for the entire floor range"}
                  {type === "3" && "Enter amount that increases per floor"}
                </Form.Text>
              </Form.Group>

            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="danger" onClick={this.closeFloorRise} disabled={inApiCall}>
              Cancel
            </Button>
            <Button onClick={this.submitFloorRise} disabled={inApiCall}>
              {inApiCall ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Saving...
                </>
              ) : (
                "Apply"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}

export default withRouter(FloorRisePreview);